// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.difficulty-header {
  color: var(--secondary-text);
  font-size: 20px;
  font-weight: var(--roboto-light);
  margin: 25px;
}

.difficulty-header-span {
  color: var(--primary-color);
  font-weight: var(--roboto-regular);
}

.select-difficulty {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 5px;
  margin: 40px;
}

.difficulty-btn,
.play-button,
.generate-button,
.back-to-categories-button {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  background-color: var(--primary-color);
  text-align: center;
  text-decoration: none;
  border: 2px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
  font-weight: var(--roboto-bold);
  color: var(--bg-color);
  font-size: 20px;
  width: 230px;
  height: 50px;
  min-width: 200px;
}

.difficulty-btn:hover,
.play-button:hover,
.generate-button:hover,
.back-to-categories-button:hover {
  background-color: var(--secondary-color);
  color: var(--primary-text);
}

.play-button:disabled,
.play-button[disabled],
.generate-button:disabled,
.generate-button[disabled] {
  background-color: lightgray;
  color: gray;
  cursor: not-allowed;
  opacity: 0.5;
}

.selected-difficulty-button {
  background-color: var(--primary-text);
  animation: pulse 1s infinite ease-in-out;
  border-color: var(--primary-text);
}

@keyframes pulse {
  0% {
    border-color: var(--primary-text);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.87);
  }
  50% {
    border-color: var(--primary-text);
    box-shadow: 0 0 0 1.2rem rgba(224, 224, 224, 0);
  }
  100% {
    border-color: var(--primary-text);
    box-shadow: 0 0 0 0 rgba(235, 235, 235, 0);
  }
}

.input-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 50px;
}

.input-icon {
  color: var(--primary-color);
  margin-right: 20px;
}

.questions-number-input {
  width: 400px;
  height: 50px;
  border-radius: 10px;
  background-color: var(--third-color);
  color: var(--primary-text);
  font-size: 25px;
  padding: 10px 30px;
  font-weight: var(--roboto-bold);
  border: 3px solid transparent;
  transition: border-color 0.7s ease;
  appearance: textfield;
  outline: none;
  text-align: center;
  min-width: 200px;
}

.questions-number-input:focus,
.questions-number-input:active {
  border-color: var(--primary-color);
}

.questions-number-input:focus::placeholder,
.questions-number-input:active::placeholder {
  visibility: hidden;
}

.questions-number-input::placeholder {
  font-size: 20px;
  font-weight: var(--roboto-thin);
}

.questions-number-input::-webkit-inner-spin-button,
.questions-number-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.action-buttons-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 5px;
  margin: 40px;
}

.generated-link {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: auto;
  height: auto;
  margin: 40px 40px 20px 40px;
}

.generated-link-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.generated-link h2 {
  bottom: 0;
  width: 100%;
  margin: 20px;
  font-weight: var(--roboto-light);
  font-style: italic;
  color: var(--secondary-text);
  font-size: 1.2rem;
}

.generated-link p {
  border-radius: 10px;
  background-color: var(--third-color);
  color: var(--primary-text);
  font-size: 18px;
  padding: 10px 30px;
  font-weight: var(--roboto-regular);
  border: 3px solid transparent;
  outline: none;
  text-align: center;
}

.copy-button {
  cursor: pointer;
  color: var(--primary-color);
}

.copy-button:hover {
  color: var(--primary-text);
}

.text-container {
  margin: 10px;
  opacity: 0;
  transition: opacity 0.4s ease-in-out;
  font-weight: var(--roboto-medium);
  color: var(--primary-color);
  font-size: 1.2rem;
}

.text-container.show {
  opacity: 1;
}

.text-container.hide {
  opacity: 0;
}

@media screen and (max-width: 1000px) {
  .select-difficulty {
    flex-direction: column;
    align-items: center;
    gap: 30px;
    margin-top: 10px;
    margin-bottom: 20px;
  }

  .action-buttons-container {
    flex-direction: column;
    align-items: center;
    gap: 30px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .difficulty-btn,
  .play-button,
  .generate-button,
  .back-to-categories-button {
    width: 100%;
    min-width: 200px;
  }

  .input-container {
    flex-direction: column;
    align-items: center;
    gap: 15px;
    margin: 10px 40px;
  }

  .questions-number-input {
    width: 100%;
    min-width: 200px;
    padding: 0px;
    margin-bottom: 10px;
  }

  .input-icon {
    display: none;
  }
}

@media screen and (max-width: 440px) {
  .questions-number-input {
    height: 50px;
  }

  .questions-number-input::placeholder {
    white-space: normal;
    font-size: 14px;
  }

  .small-separator {
    margin-bottom: 15px;
  }

  .generated-link h2 {
    font-size: 14px;
  }

  .generated-link {
    margin: 40px;
  }

  .generated-link-content {
    flex-direction: column;
  }

  .generated-link p {
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/selectedCategory/SelectedCategory.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,eAAe;EACf,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,YAAY;AACd;;AAEA;;;;EAIE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,sCAAsC;EACtC,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;EAIE,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;;;;EAIE,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE;IACE,iCAAiC;IACjC,6CAA6C;EAC/C;EACA;IACE,iCAAiC;IACjC,+CAA+C;EACjD;EACA;IACE,iCAAiC;IACjC,0CAA0C;EAC5C;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,kCAAkC;EAElC,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,iCAAiC;EACjC,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,kBAAkB;EACpB;;EAEA;;;;IAIE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".difficulty-header {\r\n  color: var(--secondary-text);\r\n  font-size: 20px;\r\n  font-weight: var(--roboto-light);\r\n  margin: 25px;\r\n}\r\n\r\n.difficulty-header-span {\r\n  color: var(--primary-color);\r\n  font-weight: var(--roboto-regular);\r\n}\r\n\r\n.select-difficulty {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 40px;\r\n  padding: 5px;\r\n  margin: 40px;\r\n}\r\n\r\n.difficulty-btn,\r\n.play-button,\r\n.generate-button,\r\n.back-to-categories-button {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 20px;\r\n  background-color: var(--primary-color);\r\n  text-align: center;\r\n  text-decoration: none;\r\n  border: 2px solid transparent;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: var(--roboto-bold);\r\n  color: var(--bg-color);\r\n  font-size: 20px;\r\n  width: 230px;\r\n  height: 50px;\r\n  min-width: 200px;\r\n}\r\n\r\n.difficulty-btn:hover,\r\n.play-button:hover,\r\n.generate-button:hover,\r\n.back-to-categories-button:hover {\r\n  background-color: var(--secondary-color);\r\n  color: var(--primary-text);\r\n}\r\n\r\n.play-button:disabled,\r\n.play-button[disabled],\r\n.generate-button:disabled,\r\n.generate-button[disabled] {\r\n  background-color: lightgray;\r\n  color: gray;\r\n  cursor: not-allowed;\r\n  opacity: 0.5;\r\n}\r\n\r\n.selected-difficulty-button {\r\n  background-color: var(--primary-text);\r\n  animation: pulse 1s infinite ease-in-out;\r\n  border-color: var(--primary-text);\r\n}\r\n\r\n@keyframes pulse {\r\n  0% {\r\n    border-color: var(--primary-text);\r\n    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.87);\r\n  }\r\n  50% {\r\n    border-color: var(--primary-text);\r\n    box-shadow: 0 0 0 1.2rem rgba(224, 224, 224, 0);\r\n  }\r\n  100% {\r\n    border-color: var(--primary-text);\r\n    box-shadow: 0 0 0 0 rgba(235, 235, 235, 0);\r\n  }\r\n}\r\n\r\n.input-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 50px;\r\n}\r\n\r\n.input-icon {\r\n  color: var(--primary-color);\r\n  margin-right: 20px;\r\n}\r\n\r\n.questions-number-input {\r\n  width: 400px;\r\n  height: 50px;\r\n  border-radius: 10px;\r\n  background-color: var(--third-color);\r\n  color: var(--primary-text);\r\n  font-size: 25px;\r\n  padding: 10px 30px;\r\n  font-weight: var(--roboto-bold);\r\n  border: 3px solid transparent;\r\n  transition: border-color 0.7s ease;\r\n  -moz-appearance: textfield;\r\n  appearance: textfield;\r\n  outline: none;\r\n  text-align: center;\r\n  min-width: 200px;\r\n}\r\n\r\n.questions-number-input:focus,\r\n.questions-number-input:active {\r\n  border-color: var(--primary-color);\r\n}\r\n\r\n.questions-number-input:focus::placeholder,\r\n.questions-number-input:active::placeholder {\r\n  visibility: hidden;\r\n}\r\n\r\n.questions-number-input::placeholder {\r\n  font-size: 20px;\r\n  font-weight: var(--roboto-thin);\r\n}\r\n\r\n.questions-number-input::-webkit-inner-spin-button,\r\n.questions-number-input::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n.action-buttons-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 40px;\r\n  padding: 5px;\r\n  margin: 40px;\r\n}\r\n\r\n.generated-link {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: auto;\r\n  height: auto;\r\n  margin: 40px 40px 20px 40px;\r\n}\r\n\r\n.generated-link-content {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\n.generated-link h2 {\r\n  bottom: 0;\r\n  width: 100%;\r\n  margin: 20px;\r\n  font-weight: var(--roboto-light);\r\n  font-style: italic;\r\n  color: var(--secondary-text);\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.generated-link p {\r\n  border-radius: 10px;\r\n  background-color: var(--third-color);\r\n  color: var(--primary-text);\r\n  font-size: 18px;\r\n  padding: 10px 30px;\r\n  font-weight: var(--roboto-regular);\r\n  border: 3px solid transparent;\r\n  outline: none;\r\n  text-align: center;\r\n}\r\n\r\n.copy-button {\r\n  cursor: pointer;\r\n  color: var(--primary-color);\r\n}\r\n\r\n.copy-button:hover {\r\n  color: var(--primary-text);\r\n}\r\n\r\n.text-container {\r\n  margin: 10px;\r\n  opacity: 0;\r\n  transition: opacity 0.4s ease-in-out;\r\n  font-weight: var(--roboto-medium);\r\n  color: var(--primary-color);\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.text-container.show {\r\n  opacity: 1;\r\n}\r\n\r\n.text-container.hide {\r\n  opacity: 0;\r\n}\r\n\r\n@media screen and (max-width: 1000px) {\r\n  .select-difficulty {\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 30px;\r\n    margin-top: 10px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .action-buttons-container {\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 30px;\r\n    margin-top: 5px;\r\n    margin-bottom: 5px;\r\n  }\r\n\r\n  .difficulty-btn,\r\n  .play-button,\r\n  .generate-button,\r\n  .back-to-categories-button {\r\n    width: 100%;\r\n    min-width: 200px;\r\n  }\r\n\r\n  .input-container {\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 15px;\r\n    margin: 10px 40px;\r\n  }\r\n\r\n  .questions-number-input {\r\n    width: 100%;\r\n    min-width: 200px;\r\n    padding: 0px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .input-icon {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 440px) {\r\n  .questions-number-input {\r\n    height: 50px;\r\n  }\r\n\r\n  .questions-number-input::placeholder {\r\n    white-space: normal;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .small-separator {\r\n    margin-bottom: 15px;\r\n  }\r\n\r\n  .generated-link h2 {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .generated-link {\r\n    margin: 40px;\r\n  }\r\n\r\n  .generated-link-content {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .generated-link p {\r\n    font-size: 13px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
